import { capitalize, get, orderBy } from 'lodash-es'
import Fuse from 'fuse.js'
import pluralize from 'pluralize'

import store from '@store'

export default {
  props: {
    serviceProvider: {
      type: Object,
      required: true
    },
    vuexModule: {
      type: String,
      required: true
    },
    headerColumns: {
      type: Array,
      required: true
    },
    activeRow: Number,
    queryParams: {
      type: Object,
      default() {
        return null
      }
    },
    selectable: {
      type: Boolean,
      default: true
    },
    sortBy: {
      type: String,
      default: 'id'
    },
    sortOrder: {
      type: String,
      default: 'desc'
    },
    actionsAllowed: {
      type: Array,
      default: () => ['delete']
    },
    actionsWidth: {
      type: Number,
      default: 70
    },
    messages: {
      type: Object,
      default: () => ({
        delete_title: null,
        delete_text: null,
        bulk_delete_title: null,
        bulk_delete_text: null
      })
    },
    label: String,
    variant: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      fetchingData: true,
      filters: [],
      selectedRows: [],
      searchQuery: '',
      pagination: {
        page: 1,
        page_size: 10,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      sorting: {
        order: 'desc',
        order_by: 'id'
      },
      rows: {
        total: 0,
        active: [],
        class: null
      },
      models: {
        filter: null
      }
    }
  },
  computed: {
    tableData() {
      var results = this.serviceProvider[this.vuexModule].results
      var sortBy = this.sorting.order_by

      if (this.sorting.order_by === this.sortBy) {
        sortBy = (item) => {
          const sortBy = this.sortBy.split('_OR_')

          if (1 < sortBy.length) {
            if (
              'string' === typeof item[sortBy[0]] ||
              'string' === item[sortBy[1]]
            )
              return item[sortBy[1]]
                ? item[sortBy[1]].toLowerCase()
                : item[sortBy[0]].toLowerCase()
            else return item[sortBy[1]] || item[sortBy[0]]
          } else {
            return 'string' === typeof item[sortBy[0]]
              ? item[sortBy[0]].toLowerCase()
              : item[sortBy[0]]
          }
        }
      }

      const fuse = new Fuse(results, {
        keys: this.searchKeys,
        includeScore: true,
        useExtendedSearch: true,
        threshold: 0.3
      })
      const filtered = {
        noNulls: results.filter((item) => {
          return get(item, this.sorting.order_by) ? true : false
        }),
        nulls: results.filter((item) => {
          return get(item, this.sorting.order_by) ? false : true
        })
      }

      results = filtered.noNulls

      if (0 < filtered.nulls.length) results = results.concat(filtered.nulls)

      if ('' !== this.searchQuery)
        results = fuse.search(`'${this.searchQuery}`).map((item) => item.item)

      if (0 < this.searchFilters.length)
        results = fuse
          .search({
            $and: this.searchFilters
          })
          .map((item) => item.item)

      results = orderBy(results, [sortBy], [this.sorting.order]).slice(
        this.from,
        this.to
      )

      return results
    },
    searchFilters() {
      let filters = []

      this.filters
        .filter((item) => 0 < item.items.length)
        .forEach((item) => {
          const items = item.items.map((i_item) => {
            if (1 < item.keys.length)
              return {
                $or: item.keys.map((k_item) => {
                  return {
                    [k_item]: `'${i_item}`
                  }
                })
              }
            else
              return {
                $path: item.keys,
                $val: `'${i_item}`
              }
          })

          filters = filters.concat(items)
        })

      return filters
    },
    searchKeys() {
      var keys = []

      this.headerColumns
        .filter((item) => 'undefined' !== typeof item.keys || item.searchable)
        .map((item) => item.keys)
        .forEach((item) => {
          keys = keys.concat(item)
        })

      return keys
    },
    to() {
      var highBound = this.from + this.pagination.page_size

      if (this.total < highBound) highBound = this.total

      return highBound
    },
    from() {
      return this.pagination.page_size * (this.pagination.page - 1)
    },
    total() {
      var results = this.serviceProvider[this.vuexModule].results
      const fuse = new Fuse(results, {
        keys: this.searchKeys,
        includeScore: true,
        useExtendedSearch: true,
        threshold: 0.3
      })

      if ('' !== this.searchQuery)
        results = fuse.search(this.searchQuery).map((item) => item.item)

      if (0 < this.searchFilters.length)
        results = fuse
          .search({
            $and: this.searchFilters
          })
          .map((item) => item.item)

      return results.length
    }
  },
  watch: {
    tableData: function (val) {
      if (0 === val.length) {
        this.pagination.page =
          1 < this.pagination.page
            ? this.pagination.page - 1
            : this.pagination.page
      }

      this.$bus.$emit('datatable-items-filtered', val)
    },
    queryParams: {
      deep: true,
      immediate: true,
      handler() {
        this.reset()
        this.fetchItems()

        this.filters = this.headerColumns
          .filter((item) => item.searchable)
          .map((item) => {
            return {
              label: item.label,
              prop: item.prop,
              keys: item.keys || item.sortBy || null,
              items: []
            }
          })
      }
    }
  },
  methods: {
    getCellValue(prop, row) {
      let props = prop.split('_OR_'),
        value = row[prop]

      props.find((item) => {
        if (row[item]) {
          value = row[item]
          return true
        }
      })

      return value
    },

    getRowClassName(row) {
      if (0 <= this.activeRow && 0 > this.rows.active.indexOf(this.activeRow)) {
        this.rows.active.push(this.activeRow)
        this.rows.class = 'bg-lighter'
      }

      if (
        this.rows.active.length &&
        0 <= this.rows.active.indexOf(row.rowIndex)
      )
        return this.rows.class
    },
    onCellClick(row, column, cell, event) {
      this.$bus.$emit('datatable-cell-click', row, column, cell, event)
    },
    onPageChange(page) {
      this.pagination.page = page
    },
    onSelectionChange(selectedRows) {
      this.selectedRows = selectedRows

      this.$bus.$emit('datatable-selection-changed', selectedRows)
    },
    onSortChange({ column, prop, order }) {
      this.sorting.order_by = column.sortBy || prop
      this.sorting.order = 'ascending' === order ? 'asc' : 'desc'
    },
    onPopoverClose() {
      this.$root.$emit('bv::hide::popover')
    },
    resetItems() {
      this.serviceProvider.set('list', null)
    },
    async fetchItems(
      params = {
        page: 1,
        page_size: 500
      },
      loading = true
    ) {
      try {
        params = Object.assign(params, this.queryParams)

        this.fetchingData = loading
        this.$bus.$emit('datatable-fetching-data', true)

        const response = await this.serviceProvider.list(params)

        this.fetchingData = false
        this.rows.active = []

        if (response.data.data.next) {
          params.page += 1

          await this.fetchItems(params, false)
        }

        this.$bus.$emit('datatable-fetching-data', false)

        this.$bus.$emit(
          'datatable-items-fetched',
          this.serviceProvider[this.vuexModule].results
        )
      } catch (e) {
        this.fetchingData = false
      }
    },
    async deleteItem(index, row) {
      const swal = await this.$swal({
        title: this.messages.delete_title || 'Are you sure?',
        text: this.messages.delete_text || "You won't be able to revert this.",
        type: 'warning',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!swal.isConfirmed) return false

      var params = {
        id: row.id
      }

      this.rows.active.push(index)
      this.rows.class = 'text-white bg-translucent-danger processing'

      if ('reports' == this.vuexModule && this.queryParams.assignee)
        params.assignee = this.queryParams.assignee

      const response = await this.serviceProvider.delete(params)

      const apiStatus = get(response, 'data.data.status', 200)
      const apiMessage = get(response, 'data.data.message', 'Request completed.')

      this.$toasted.show(apiMessage, {
        type: apiStatus === 200 ? 'success' : 'error'
      })

      // Only remove from UI if delete actually happened
      if (apiStatus === 200) {
        this.$bus.$emit('datatable-item-deleted', row)
      }

      this.rows.active = []
      this.rows.status = null
    },
    async bulkDelete(items) {
      const swal = await this.$swal({
        title:
          this.messages.bulk_delete_title ||
          `Delete ${this.label || this.vuexModule}?`,
        text: this.messages.bulk_delete_text || 'This action cannot be undone.',
        type: 'warning',
        confirmButtonText: 'Delete'
      })

      if (!swal.isConfirmed) return false

      this.rows.class = 'text-white bg-translucent-danger processing'
      this.rows.active = items.map((item) => {
        return this.tableData.findIndex((iitem) => iitem.id == item.id)
      })

      for (const item of items) {
        var params = {
          id: item.id
        }

        if ('reports' == this.vuexModule && this.queryParams.assignee)
          params.assignee = this.queryParams.assignee

        await this.serviceProvider.delete(params)

        this.$bus.$emit('datatable-item-deleted', item)
      }

      this.$toasted.show(`${capitalize(this.vuexModule)} deleted succesfully.`)

      this.rows.active = []
      this.rows.status = null
    },
    addFilter(label) {
      if (this.models.filter) {
        const index = this.filters.findIndex((item) => item.label === label)

        if (0 <= index) {
          if (-1 == this.filters[index].items.indexOf(this.models.filter)) {
            this.filters[index].items.push(this.models.filter)
            this.models.filter = null
          }
        }
      }

      this.onPopoverClose()
    },
    removeFilter(index, filter) {
      this.filters[index].items.splice(filter, 1)
    },
    reset() {
      this.resetItems()

      Object.assign(this.$data, this.$options.data.apply(this))
    }
  },
  created() {
    this.sorting.order = this.sortOrder
    this.sorting.order_by = this.sortBy

    this.resetItems()
  },
  mounted() {
    this.$bus.trackEvent('datatable-reload', () => {
      this.reset()
      this.fetchItems()
    })

    this.$bus.trackEvent('datatable-search', (keyword) => {
      this.searchQuery = keyword
    })

    this.$bus.trackEvent('datatable-processing-rows', (rows) => {
      if (rows.length) {
        this.rows.active = rows
          .filter((item) => 0 <= this.tableData.indexOf(item))
          .map((item) => this.tableData.indexOf(item))
        this.rows.class = 'bg-translucent-white processing'
      } else {
        this.rows.active = []
        this.rows.class = null
      }
    })

    this.$bus.trackEvent('datatable-unselect-rows', () => {
      this.selectedRows = []

      if (this.$refs.datatable) this.$refs.datatable.clearSelection()
    })

    this.$bus.trackEvent('datatable-remove-item', (payload) => {
      store.commit(
        `DELETE_${pluralize.singular(this.vuexModule).toUpperCase()}`,
        {
          data: payload
        }
      )
    })
  },
  beforeDestroy() {
    this.reset()
  }
}
